<app-autocomplete-select
  placeholder="{{'search.company' | translate}}"
  [options]="options"
  [(ngModel)]="value"
  style="width: 100%">
</app-autocomplete-select>
